import { Link } from 'react-router-dom'
import styles from './CTABanner.module.css'

const CTABanner = () => {
  return (
    <section className={styles.ctaBanner}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          Need a Quick
          <span className={styles.highlight}>HVAC Assistance?</span>
        </h2>
        <Link to="/service-requests" className={styles.ctaButton}>
          Send us a Request
        </Link>
      </div>
    </section>
  )
}

export default CTABanner
